import React, { useState, useEffect, useRef } from "react";
import ApiServices from "../Services/ApiServices";
import { toastHelper } from "../../Helpers/toastHelper";

const UploadApk = () => {
  const [file, setFile] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [loading, setLoading] = useState(false);
  const [fileInfo, setFileInfo] = useState(null);
  const [infoLoading, setInfoLoading] = useState(true);
  const fileInputRef = useRef();
  const [dragActive, setDragActive] = useState(false);

  useEffect(() => {
    fetchFileInfo();
  }, []);

  const fetchFileInfo = async () => {
    setInfoLoading(true);
    try {
      const data = await ApiServices.get("App/apk/Info");
      setFileInfo(data);
    } catch (err) {
      setFileInfo(null);
    } finally {
      setInfoLoading(false);
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      setFile(e.dataTransfer.files[0]);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragActive(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragActive(false);
  };

  const uploadFile = async () => {
    if (!file) {
      toastHelper.error("يرجى اختيار ملف APK أولاً.");
      return;
    }
    setLoading(true);
    setUploadProgress(0);
    try {
      const formData = new FormData();
      formData.append("apk", file);
      const config = {
        onUploadProgress: (progressEvent) => {
          let percentCompleted = 0;
          if (progressEvent.total && progressEvent.total > 0) {
            percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            if (percentCompleted > 100) percentCompleted = 100;
          } else {
            percentCompleted = progressEvent.loaded > 0 ? 99 : 0;
          }
          setUploadProgress(percentCompleted);
        },
      };
      await ApiServices.post("App/apk/upload", formData, true, 500000, config);
      setFile(null);
      toastHelper.success("تم رفع التطبيق بنجاح!");
      fetchFileInfo();
    } catch (err) {
      let errorMsg = err?.message || "فشل الرفع";
      if (err?.errors && typeof err.errors === "object") {
        const firstKey = Object.keys(err.errors)[0];
        if (
          firstKey &&
          Array.isArray(err.errors[firstKey]) &&
          err.errors[firstKey].length > 0
        ) {
          errorMsg = err.errors[firstKey][0];
        }
      }
      toastHelper.error(errorMsg);
    } finally {
      setLoading(false);
      setUploadProgress(100);
      setTimeout(() => setUploadProgress(0), 2000);
    }
  };

  // Helper for file size
  const formatSize = (size) => {
    if (!size) return "-";
    if (typeof size === "string" && size.match(/KB|MB|GB/)) return size;
    const kb = size / 1024;
    if (kb < 1024) return kb.toFixed(1) + " KB";
    const mb = kb / 1024;
    if (mb < 1024) return mb.toFixed(1) + " MB";
    return (mb / 1024).toFixed(1) + " GB";
  };

  return (
    <div className="win11-explorer-root" dir="rtl">
      {/* Toolbar */}
      <div className="explorer-toolbar">
        <div className="explorer-path">
          <span className="explorer-folder-icon">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
              <path
                d="M2 6.75A2.75 2.75 0 0 1 4.75 4h3.19c.66 0 1.3.26 1.77.73l1.13 1.13c.23.23.54.36.86.36h6.6A2.75 2.75 0 0 1 21 9.25v8A2.75 2.75 0 0 1 18.25 20H5.75A2.75 2.75 0 0 1 3 17.25V6.75Z"
                fill="#FFD700"
              />
            </svg>
          </span>
          <span className="explorer-path-text">
            {fileInfo && fileInfo.directory_path
              ? fileInfo.directory_path
              : "android > app > build > outputs > apk > release"}
          </span>
        </div>
        <div className="explorer-actions">
          <button
            className="explorer-action-btn"
            onClick={() => fileInputRef.current.click()}
            disabled={loading}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 16V4m0 0l-4 4m4-4l4 4"
                stroke="#7a6ad8"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <rect x="4" y="16" width="16" height="4" rx="2" fill="#7a6ad8" />
            </svg>
            <span>رفع APK</span>
          </button>
        </div>
      </div>
      {/* File List Section */}
      <div className="explorer-content">
        <div className="explorer-list-header">
          <span></span>
          <span>الاسم</span>
          <span>النوع</span>
          <span>الحجم</span>
          <span>تاريخ التعديل</span>
        </div>
        <div className="explorer-list-body">
          {/* APK file row */}
          {infoLoading ? (
            <div
              className="explorer-row explorer-loading"
              style={{ gridColumn: "1 / -1" }}
            >
              جاري جلب معلومات الملف...
            </div>
          ) : fileInfo ? (
            <>
              <div className="explorer-row">
                <span className="explorer-file-icon">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                    <rect width="24" height="24" rx="6" fill="#F3F6FD" />
                    <path
                      d="M7 4C6.44772 4 6 4.44772 6 5V19C6 19.5523 6.44772 20 7 20H17C17.5523 20 18 19.5523 18 19V9.41421C18 9.149 17.8946 8.89464 17.7071 8.70711L13.2929 4.29289C13.1054 4.10536 12.851 4 12.5858 4H7Z"
                      fill="#7a6ad8"
                    />
                    <rect
                      x="9"
                      y="14"
                      width="6"
                      height="1.5"
                      rx="0.75"
                      fill="#7a6ad8"
                    />
                    <rect
                      x="9"
                      y="17"
                      width="4"
                      height="1.5"
                      rx="0.75"
                      fill="#7a6ad8"
                    />
                  </svg>
                </span>
                <span className="explorer-file-name">{fileInfo.file_name}</span>
                <span className="explorer-file-type">
                  {fileInfo.file_type || "APK"}
                </span>
                <span className="explorer-file-size">
                  {formatSize(fileInfo.size)}
                </span>
                <span className="explorer-file-date">
                  {new Date(fileInfo.last_write_time).toLocaleString("ar-EG")}
                </span>
              </div>
              {/* <div className="explorer-details-row">
                <div><span className="explorer-details-label">اسم الملف:</span> <span className="explorer-details-value">{fileInfo.file_name}</span></div>
                <div><span className="explorer-details-label">المسار:</span> <span className="explorer-details-value">{fileInfo.directory_path}</span></div>
                <div><span className="explorer-details-label">الحجم:</span> <span className="explorer-details-value">{fileInfo.size}</span></div>
                <div><span className="explorer-details-label">النوع:</span> <span className="explorer-details-value">{fileInfo.file_type || "APK"}</span></div>
                <div><span className="explorer-details-label">تاريخ الإنشاء:</span> <span className="explorer-details-value">{new Date(fileInfo.creation_time).toLocaleString("ar-EG")}</span></div>
                <div><span className="explorer-details-label">آخر تعديل:</span> <span className="explorer-details-value">{new Date(fileInfo.last_write_time).toLocaleString("ar-EG")}</span></div>
                <div><span className="explorer-details-label">آخر وصول:</span> <span className="explorer-details-value">{new Date(fileInfo.last_access_time).toLocaleString("ar-EG")}</span></div>
              </div> */}
            </>
          ) : (
            <div
              className="explorer-row explorer-error"
              style={{ gridColumn: "1 / -1" }}
            >
              لا توجد معلومات متاحة للملف.
            </div>
          )}
        </div>
      </div>
      {/* Upload Section */}
      <div
        className={`explorer-uploader${dragActive ? " drag-active" : ""}`}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onClick={() => fileInputRef.current.click()}
      >
        <input
          type="file"
          accept=".apk"
          onChange={handleFileChange}
          disabled={loading}
          ref={fileInputRef}
          style={{ display: "none" }}
        />
        <div className="explorer-uploader-content">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
            <rect width="48" height="48" rx="12" fill="#F3F6FD" />
            <path
              d="M24 32V16m0 0l-6 6m6-6l6 6"
              stroke="#7a6ad8"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <rect x="12" y="32" width="24" height="6" rx="3" fill="#7a6ad8" />
          </svg>
          <div className="explorer-uploader-text">
            {file ? (
              <span>
                الملف المحدد: <b>{file.name}</b>
              </span>
            ) : (
              <span>اسحب ملف APK هنا أو اضغط لاختياره</span>
            )}
          </div>
        </div>
      </div>
      <button
        className="explorer-upload-btn"
        onClick={uploadFile}
        disabled={loading || !file}
      >
        {loading ? "جاري الرفع..." : "رفع التطبيق"}
      </button>
      {(loading || uploadProgress > 0) && (
        <div className="explorer-progress-container">
          <div
            className="explorer-progress-bar"
            style={{ width: `${uploadProgress}%` }}
          />
          <div className="explorer-progress-text">{uploadProgress}%</div>
        </div>
      )}
      <style jsx>{`
        .win11-explorer-root {
          background: #181a1b;
          border-radius: 18px;
          box-shadow: 0 4px 24px rgba(122, 106, 216, 0.13);
          padding: 2.5rem 2rem 2rem 2rem;
          min-width: 85%;
          margin: 0 auto;
            font-family: "Zain", sans-serif;
          color: #fff;
        }
        .explorer-toolbar {
          display: flex;
          align-items: center;
          justify-content: space-between;
          background: #23272e;
          border-radius: 10px;
          padding: 0.7rem 1.2rem;
          margin-bottom: 1.5rem;
          box-shadow: 0 2px 8px rgba(122, 106, 216, 0.07);
        }
        .explorer-path {
          display: flex;
          align-items: center;
          gap: 0.7rem;
        }
        .explorer-folder-icon {
          display: flex;
          align-items: center;
        }
        .explorer-path-text {
          color: #ffe066;
          font-weight: 700;
          font-size: 1.1rem;
        }
        .explorer-actions {
          display: flex;
          gap: 0.7rem;
        }
        .explorer-action-btn {
          background: #fff;
          color: #7a6ad8;
          border: none;
          border-radius: 8px;
          font-size: 1rem;
          font-weight: 700;
          padding: 7px 18px 7px 14px;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          transition: background 0.2s, color 0.2s, transform 0.2s;
        }
        .explorer-action-btn:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }
        .explorer-action-btn:hover:not(:disabled) {
          background: #ffe066;
          color: #7a6ad8;
        }
        .explorer-content {
          background: #23272e;
          border-radius: 10px;
          margin-bottom: 1.5rem;
          box-shadow: 0 2px 8px rgba(122, 106, 216, 0.07);
        }
        .explorer-list-header,
        .explorer-row {
          display: grid;
          grid-template-columns: 40px 2.5fr 1fr 1fr 2fr;
          align-items: center;
          padding: 0.7rem 1.2rem;
          font-size: 1rem;
        }
        .explorer-list-header {
          color: #ffe066;
          font-weight: 700;
          border-bottom: 1px solid #2d3137;
        }
        .explorer-row {
          color: #fff;
          border-bottom: 1px solid #23272e;
          transition: background 0.2s;
        }
        .explorer-row:last-child {
          border-bottom: none;
        }
        .explorer-row:hover {
          background: #23272e;
        }
        .explorer-file-icon {
          display: flex;
          align-items: center;
        }
        .explorer-file-name {
          font-weight: 600;
          text-wrap-mode: wrap;
          width: 88%;
        }
        .explorer-file-type {
          color: #ffe066;
          font-weight: 600;
        }
        .explorer-file-size {
          color: #7a6ad8;
        }
        .explorer-file-date {
          color: #bdbdbd;
        }
        .explorer-loading,
        .explorer-error {
          grid-column: 1 / -1;
          text-align: center;
          color: #ffe066;
          font-size: 1rem;
          padding: 1.2rem 0;
        }
        .explorer-uploader {
          background: #23272e;
          border: 2px dashed #7a6ad8;
          border-radius: 12px;
          margin: 1.5rem 0 0.7rem 0;
          padding: 2.2rem 1.2rem;
          text-align: center;
          cursor: pointer;
          transition: border 0.2s, background 0.2s;
        }
        .explorer-uploader.drag-active {
          border: 2.5px solid #ffe066;
          background: #1a1c1e;
        }
        .explorer-uploader-content {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 0.7rem;
        }
        .explorer-uploader-text {
          color: #fff;
          font-size: 1.1rem;
          font-weight: 600;
        }
        .explorer-upload-btn {
          background: linear-gradient(90deg, #ffe066 0%, #7a6ad8 100%);
          color: #fff;
          border: none;
          border-radius: 24px;
          font-size: 1rem;
          font-weight: 700;
          padding: 10px 28px;
          cursor: pointer;
            font-family: "Zain", sans-serif;
          margin: 0 auto 0.7rem auto;
          display: block;
          transition: background 0.2s, color 0.2s, transform 0.2s;
        }
        .explorer-upload-btn:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }
        .explorer-upload-btn:hover:not(:disabled) {
          background: #ffe066;
          color: #7a6ad8;
        }
        .explorer-progress-container {
          width: 100%;
          background: #e0e0e0;
          border-radius: 8px;
          margin-top: 1rem;
          position: relative;
          height: 18px;
          display: flex;
          align-items: center;
        }
        .explorer-progress-bar {
          height: 100%;
          background: linear-gradient(90deg, #7a6ad8 0%, #ffe066 100%);
          border-radius: 8px;
          transition: width 0.3s;
        }
        .explorer-progress-text {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          color: #3949ab;
          font-weight: bold;
          font-size: 1rem;
        }
        .explorer-details-row {
          background: #23272e;
          border-radius: 10px;
          margin: 0.7rem 0 0.5rem 0;
          padding: 1.1rem 1.2rem 0.7rem 1.2rem;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 0.7rem 2.5rem;
          font-size: 1.02rem;
        }
        .explorer-details-label {
          color: #ffe066;
          font-weight: 700;
          margin-left: 0.3rem;
        }
        .explorer-details-value {
          color: #fff;
          font-weight: 500;
        }
        @media (max-width: 700px) {
          .win11-explorer-root {
            padding: 1.2rem 0.2rem;
            min-width: 99vw;
          }
          .explorer-toolbar,
          .explorer-content {
            padding: 0.5rem 0.2rem;
          }
          .explorer-list-header,
          .explorer-row {
            font-size: 0.95rem;
            padding: 0.5rem 0.2rem;
            grid-template-columns: 32px 2.5fr 1fr 1fr 2fr;
          }
          .explorer-uploader {
            padding: 1.2rem 0.2rem;
          }
          .explorer-details-row {
            grid-template-columns: 1fr;
            font-size: 0.97rem;
            padding: 0.7rem 0.2rem 0.5rem 0.2rem;
          }
        }
      `}</style>
    </div>
  );
};

export default UploadApk;
